import { format } from 'libphonenumber-js'
import _ from 'lodash'
import React from 'react'
import { connect } from 'react-redux'

import { FriendlyDateTime } from '../Date/friendly-date-time'
import { Button } from '../NarusMaterial'

import * as Actions from './enrollmentActions2'

class EnrollmentControl2 extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      revoked: false,
      invited: false,
      resent: false
    }
  }

  componentDidMount () {
    const { dispatch, patientId, personId } = this.props
    const enrl = this.props.enrollments[this.props.personId]

    if (!enrl) {
      dispatch(Actions.searchEnrollment(personId, patientId))
    }
  }

  getEnrollmentForPatient () {
    const { enrollments, personId } = this.props
    return enrollments[personId]
  }

  renderResend = enrl => {
    return (
      <div className='col-xs-2'>
        <Button
          label='Resend'
          disabled={
            this.props.formChanged || this.props.disabled || this.state.resent
          }
          onClick={() => {
            this.setState({ resent: true })
            this.props.dispatch(Actions.resendEmail(enrl.id))
              .then(() => {
                this.props.dispatch(Actions.searchEnrollment(this.props.personId, this.props.patientId))
              })
          }}
        />
      </div>
    )
  }

  render () {
    const { errorMessage, clients, clientName, supportMember, roll } =
      this.props
    const enrl = this.props.enrollments[this.props.personId]
    let initiatorName = null
    let dom = null

    const myClient = _.find(clients, c => c.clientName === clientName)

    if (enrl && enrl.initiatedBy) {
      const suffix = enrl.initiatedBy.meta.suffix
        ? enrl.initiatedBy.meta.suffix.join(', ')
        : ''
      initiatorName = [
        enrl.initiatedBy.meta.given,
        enrl.initiatedBy.meta.family,
        suffix
      ].join(' ')
    }

    const enrollmentMessage = () => {
      if (errorMessage) {
        return <div className='col-xs-6'>{errorMessage}</div>
      }
      if (supportMember) {
        return (
          <div className='col-xs-6'>Enrollment process has not started</div>
        )
      }
      return (
        <div className='col-xs-6'>
          Enrollment process has not started
          {(myClient &&
            myClient.selfEnrollment &&
            !(roll === 'ff' || roll === 'caregiver') &&
            ', eligible for self-enrollment.') ||
            ', not eligible for self-enrollment.'}
        </div>
      )
    }

    if (enrl && enrl.error) {
      dom = (
        <div>
          <p>An error has occurred.</p>
        </div>
      )
    } else if (enrl === false || enrl === undefined) {
      dom = (
        <div className='row'>
          <div className='col-xs-2'>None</div>
          {enrollmentMessage()}
          <div className='col-xs-2'>
            <Button
              label='Invite'
              disabled={
                this.props.formChanged ||
                this.props.disabled ||
                this.state.invited
              }
              onClick={() => {
                this.setState({
                  invited: true,
                  resent: false,
                  revoked: false
                })
                return this.props.dispatch(
                  Actions.startEnrollment(
                    this.props.personId,
                    this.props.patientId,
                    this.props.role,
                    this.props.clientName
                  )
                )
              }}
            />
          </div>
          <div className='col-xs-2' />
        </div>
      )
    } else if (enrl && enrl.loading === true) {
      dom = (
        <div className='row'>
          <div className='col-xs-12'>Loading data...</div>
        </div>
      )
    } else if (enrl && enrl.status === 'started' && !enrl.initiatedBy) {
      dom = (
        <div className='row'>
          <div className='col-xs-2'>Started</div>
          <div className='col-xs-6'>
            Patient started
            {' '}
            {!(roll === 'ff' || roll === 'caregiver')
              ? 'self-enrollment '
              : `enrollment by ${initiatorName} `}
            at
            {' '}
            <FriendlyDateTime datetime={enrl.created_at} />
            {' '}
            {enrl.expired ? '(Expired)' : ''}
          </div>
          {this.renderResend(enrl)}
          <div className='col-xs-2'>
            <Button
              label='Revoke'
              disabled={this.state.revoked}
              onClick={() => {
                this.setState({
                  revoked: true,
                  invited: false
                })
                return this.props.dispatch(
                  Actions.revokeEnrollment(
                    enrl.id,
                    this.props.personId,
                    this.props.patientId
                  )
                )
              }}
            />
          </div>
          <div className='col-xs-12'>
            <div
              className='row'
              style={{ color: '#c2c2c2' }}
            >
              <div className='col-xs-3 col-xs-offset-2'>
                {this.getEnrollmentForPatient().phone &&
                  format(
                    this.getEnrollmentForPatient().phone,
                    'US',
                    'International'
                  )}
              </div>
              <div className='col-xs-3'>
                {this.getEnrollmentForPatient().email}
              </div>
            </div>
          </div>
        </div>
      )
    } else if (enrl && enrl.status !== 'finished') {
      dom = (
        <div className='row'>
          <div className='col-xs-2'>Invited</div>
          <div className='col-xs-6'>
            Invitation sent by
            {' '}
            {initiatorName}
            {' '}
            <FriendlyDateTime datetime={enrl.emailSentAt} />
            {' '}
            {enrl.expired ? '(Expired)' : ''}
          </div>
          {this.renderResend(enrl)}
          <div className='col-xs-2'>
            <Button
              label='Revoke'
              disabled={this.state.revoked}
              onClick={() => {
                this.setState({
                  revoked: true,
                  invited: false
                })
                return this.props.dispatch(
                  Actions.revokeEnrollment(
                    enrl.id,
                    this.props.personId,
                    this.props.patientId
                  )
                )
              }}
            />
          </div>
          <div className='col-xs-12'>
            <div
              className='row'
              style={{ color: '#c2c2c2' }}
            >
              <div className='col-xs-3 col-xs-offset-2'>
                {this.getEnrollmentForPatient().phone &&
                  format(
                    this.getEnrollmentForPatient().phone,
                    'US',
                    'International'
                  )}
              </div>
              <div className='col-xs-3'>
                {this.getEnrollmentForPatient().email}
              </div>
            </div>
          </div>
        </div>
      )
    } else if (enrl && enrl.status === 'finished') {
      let enrolledByMessage = ''

      if (initiatorName) {
        enrolledByMessage = `Enrolled by ${initiatorName}`
      } else {
        enrolledByMessage = 'Self-enrolled'
      }

      dom = (
        <div className='row'>
          <div className='col-xs-2'>Enrolled</div>
          <div className='col-xs-6'>
            {enrolledByMessage}
            {' '}
            <FriendlyDateTime datetime={enrl.updated_at} />
          </div>
          <div className='col-xs-2'>
            <Button
              label='Revoke'
              disabled={this.state.revoked}
              onClick={() => {
                this.setState({
                  revoked: true,
                  invited: false
                })
                return this.props.dispatch(
                  Actions.revokeAccess(
                    this.props.personId,
                    this.props.patientId,
                    this.props.clientName
                  )
                )
              }}
            />
          </div>
          <div className='col-xs-2' />
        </div>
      )
    }
    return <div className='enrollment nh-margin-bottom-2'>{dom}</div>
  }
}
const mapStateToProps = redux => ({
  enrollments: redux.enrollments2,
  patientId: redux.globalVars.params.id || null,
  clients: redux.globalVars.clients || [],
  clientName: redux.patient.clientName || ''
})

export default connect(mapStateToProps)(EnrollmentControl2)
